import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { createRequestOption } from '../../model/request-util';
import { SERVER_API_URL } from '../../../environment.constants';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';
import { ParamContext } from '../../service/param.context';
import { ScaleDetails } from '../model/scale-details';
import { ScaleSearchRequest } from '../model/scale-search-request.model';

@Injectable()
export class ScaleService {

    constructor(
        private http: HttpClient,
        private paramContext: ParamContext
    ) {
    }

    getScales(): Observable<ScaleDetails[]> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/scales?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<ScaleDetails[]>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    queryScales(query: string): Observable<HttpResponse<ScaleDetails[]>> {
        return this.http.get<ScaleDetails[]>(SERVER_API_URL + `crops/${this.paramContext.cropName}/scales/search?query=` + query, { observe: 'response' });
    }

    searchScales(search: ScaleSearchRequest, req: any): Observable<HttpResponse<ScaleDetails[]>> {
        const params = createRequestOption(req);
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/scales/search`;
        return this.http.post<ScaleDetails[]>(url, search, {
            params, observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true)
        });
    }

    getScaleId(scaleId: string): Observable<ScaleDetails> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/scales/${scaleId}?programUUID=${this.paramContext.programUUID}`;
        return this.http.get<ScaleDetails>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    update(scale: ScaleDetails): Observable<HttpResponse<ScaleDetails>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/scales/${scale.id}?programUUID=${this.paramContext.programUUID}`;
        return this.http.put<ScaleDetails>(url, scale, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    create(scale: ScaleDetails): Observable<HttpResponse<{ id: string }>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/scales?programUUID=${this.paramContext.programUUID}`;
        return this.http.post<{ id: string }>(url, scale, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    delete(scaleId: string): Observable<HttpResponse<any>> {
        const url = SERVER_API_URL + `crops/${this.paramContext.cropName}/scales/${scaleId}?programUUID=${this.paramContext.programUUID}`;
        return this.http.delete<any>(url, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

}
